/* ca-header-menu.js
   Toggle header <details> elements open on hover/focus for desktop
   so submenus behave like classic dropdowns while preserving
   details-based semantics for keyboard users.
*/
(function () {
  const mq = window.matchMedia('(min-width: 750px)');

  function shouldActivate() {
    return mq.matches;
  }

  function init() {
    // Sélectionner TOUS les details du header qui ont un sous-menu
    const detailsNodes = Array.from(
      document.querySelectorAll('header details')
    ).filter(det => det.querySelector('.header__submenu'));

    console.log('Menus trouvés:', detailsNodes.length); // Debug

    detailsNodes.forEach((det) => {
      // ✅ Exclure spécifiquement le sélecteur de langue (localization-form)
      if (det.closest('localization-form') || 
          det.classList.contains('disclosure__button') ||
          det.querySelector('.localization-form__select')) {
        return;
      }

      console.log('Menu détecté:', det.id); // Pour debug

      // Mouse interactions
      det.addEventListener('mouseenter', () => {
        if (shouldActivate()) {
          console.log('Mouseenter sur', det.id);
          det.open = true;
        }
      });
      
      det.addEventListener('mouseleave', () => {
        if (shouldActivate()) {
          console.log('Mouseleave sur', det.id);
          det.open = false;
        }
      });

      // Keyboard interactions
      det.addEventListener('focusin', () => {
        if (shouldActivate()) det.open = true;
      });

      det.addEventListener('focusout', (e) => {
        if (!shouldActivate()) return;
        const related = e.relatedTarget;
        if (!related || !det.contains(related)) {
          det.open = false;
        }
      });

      // Close on Escape
      det.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' || e.key === 'Esc') {
          if (det.open) {
            det.open = false;
            const summary = det.querySelector('summary');
            if (summary) summary.focus();
          }
        }
      });
    });

    // Listen for viewport changes
    mq.addEventListener?.('change', (ev) => {
      if (!ev.matches) {
        document.querySelectorAll('details[open]').forEach((d) => {
          if (!d.closest('localization-form') && 
              !d.querySelector('.localization-form__select')) {
            d.open = false;
          }
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();